// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/font/Cookies.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  /* // font-family: "Source Sans Pro", sans-serif; */
  transition: all 0.4s ease-in-out;
}

@font-face {
  font-family: cookies;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.sweet-loading{
  /* border: 2px solid red; */
  background-color: rgba(0,0,0,.1);
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,mDAAmD;EACnD,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,4CAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":["\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  /* // font-family: \"Source Sans Pro\", sans-serif; */\n  transition: all 0.4s ease-in-out;\n}\n\n@font-face {\n  font-family: cookies;\n  src: url(./assets/font/Cookies.ttf);\n}\n\n.sweet-loading{\n  /* border: 2px solid red; */\n  background-color: rgba(0,0,0,.1);\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
